@if (flag) {
  <div class="flag flag-{{ flag }}"></div>
}